import cx from 'classnames';
import { MouseEventHandler, ReactNode } from 'react';

import { Space } from '@flipster/ui/Space';

import styles from './priceRateButtons.module.scss';

interface Props {
  items: string[] | { label: ReactNode; value: string }[];
  onClick: MouseEventHandler<HTMLButtonElement>;
  className?: string;
}

const PriceRateButtons = ({ items, onClick, className }: Props) => {
  return (
    <Space space='medium'>
      {items.map((item) => {
        if (typeof item === 'string') {
          return (
            <button type='button' value={item} key={item} onClick={onClick} className={cx(styles.wrapper, className)}>
              {item}%
            </button>
          );
        }
        return (
          <button
            type='button'
            value={item.value}
            key={item.value}
            onClick={onClick}
            className={cx(styles.wrapper, className)}
          >
            {item.label}
          </button>
        );
      })}
    </Space>
  );
};

export default PriceRateButtons;
